import type { ReactNode } from 'react'
import { ESTILO_CARTAO_NOVO, ESTILO_ICONE_CARTAO } from './estilosDaFornecedora'

// Um card das abas Identificacao e Localizacao (pedido dela, 28/09): icone +
// titulo, sem subtitulo -- o mesmo visual limpo da Politica Comercial.
export default function SecaoCadastro({ icone, titulo, children }: { icone: ReactNode; titulo: string; children: ReactNode }) {
  return (
    <section className={`${ESTILO_CARTAO_NOVO} space-y-3`}>
      <div className="flex items-center gap-2">
        <span className={ESTILO_ICONE_CARTAO}>{icone}</span>
        <h3 className="text-sm font-semibold text-slate-800">{titulo}</h3>
      </div>
      {children}
    </section>
  )
}

// Campo com icone dentro, a esquerda (telefone, e-mail, site...).
export function ComIcone({ icone, children }: { icone: ReactNode; children: ReactNode }) {
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400">{icone}</span>
      {children}
    </div>
  )
}
